import { ClientResponse } from '../../../model/ClientResponse';
import { indexerAxiosInstance } from '../../configuration/axiosConfig';

interface Props {
  nazov: string;
  iri: string;
}

interface VyhladavanieItem {
  iri: string;
  popis: string;
  typ: string;
}

// eslint-disable-next-line import/prefer-default-export
export async function getSearchData(
  value: string,
  requestPath: string,
  path: string,
  options: object,
):
  Promise<ClientResponse<Props[]>> {
  const {
    data,
    status: responseCode,
  } = await indexerAxiosInstance.get<VyhladavanieItem[]>(requestPath, {
    params: {
      dopyt: value,
      rows: 50,
    },
    ...options,
  });

  const mappedData = data
    .filter((item) => item.typ !== 'nadpis.predpisZbierky')
    .map((item) => ({
      iri: path + item.iri,
      nazov: item.popis,
    }));

  return {
    data: mappedData,
    responseCode,
  };
}
